/**
 * Included into the footer of pages.
 */

import './lib/AnimationEasing';

import {videoModals} from "./component/VideoModal/VideoModal";
videoModals({
	// If you want a custom play button, uncomment this line
	// customPlayButton: require("./component/VideoModal/VideoModal.svg?string")
});


// ---------------------------------------------------------------------------------------------- //
// Animations
//
// SEE EXAMPLE BELOW:
//
// import InViewObserver from './lib/InViewObserver';
// InViewObserver.createInstance(
// 	{
// 		observeSelector: '.pageContent > .wp-block-group, .callToAction, .site-footer__content',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	},
// 	{
// 		observeSelector: '.decorativeShape__canvas, .site-footer__donutCanvas',
// 		minimum: 20,
// 		minimumUnit: "px"
// 	}
// );
// ---------------------------------------------------------------------------------------------- //
